module.exports = __webpack_public_path__ + "static/assets/414ef5f96bd00df3c7b4e175244ddaf3.png";